class n {
  /**
   * Stores a string value in localStorage with an expiration time
   * @param key - The storage key
   * @param value - The string value to store
   * @param ttlSeconds - Time to live in seconds
   */
  static setWithExpiry(t, o, e) {
    if (typeof window > "u" || !("localStorage" in window))
      return;
    const i = {
      value: o,
      expiry: Date.now() + e * 1e3
    };
    localStorage.setItem(t, JSON.stringify(i));
  }
  /**
   * Retrieves a string value from localStorage, checking if it has expired
   * @param key - The storage key
   * @returns The stored string value or undefined if not found/expired
   */
  static getWithExpiry(t) {
    if (typeof window > "u" || !("localStorage" in window))
      return;
    const o = localStorage.getItem(t);
    if (o)
      try {
        const e = JSON.parse(o);
        if (Date.now() > e.expiry) {
          localStorage.removeItem(t);
          return;
        }
        return e.value;
      } catch (e) {
        console.warn("Trying to access local storage item without expiry", e);
        return;
      }
  }
  /**
   * Stores any serializable value in localStorage with an expiration time
   * @param key - The storage key
   * @param value - The value to store (any serializable type)
   * @param ttlSeconds - Time to live in seconds
   */
  static setWithExpiryTyped(t, o, e) {
    if (typeof window > "u" || !("localStorage" in window))
      return;
    const i = {
      value: o,
      expiry: Date.now() + e * 1e3
    };
    localStorage.setItem(t, JSON.stringify(i));
  }
  /**
   * Retrieves a typed value from localStorage, checking if it has expired
   * @param key - The storage key
   * @returns The stored value of type T or undefined if not found/expired
   * @example
   * ```typescript
   * // Store and retrieve a number
   * LocalStorage.setWithExpiryTyped('count', 42, 3600);
   * const count = LocalStorage.getWithExpiryTyped<number>('count'); // 42
   *
   * // Store and retrieve an object
   * LocalStorage.setWithExpiryTyped('user', { name: 'John', age: 30 }, 3600);
   * const user = LocalStorage.getWithExpiryTyped<{ name: string; age: number }>('user');
   * ```
   */
  static getWithExpiryTyped(t) {
    if (typeof window > "u" || !("localStorage" in window))
      return;
    const o = localStorage.getItem(t);
    if (o)
      try {
        const e = JSON.parse(o);
        if (Date.now() > e.expiry) {
          localStorage.removeItem(t);
          return;
        }
        return e.value;
      } catch (e) {
        console.warn("Trying to access local storage item without expiry", e);
        return;
      }
  }
  /**
   * Removes an item from localStorage
   * @param key - The storage key to remove
   */
  static remove(t) {
    typeof window > "u" || !("localStorage" in window) || localStorage.removeItem(t);
  }
}
export {
  n as LocalStorage
};
